import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import {connect } from 'react-redux';
import { remove_user } from 'src/store/action';
import { Backdrop, CircularProgress } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import firebase from 'src/config/firebase';

const ColorCircularProgress = withStyles({
    root: {
      color: '#0F467A',
    },
})(CircularProgress);

const withAuth = (WrappedComponent) => {
    const AuthComponent = (props) => {
      const { company, user, company_id } = props;
      const copyComp = Object.assign({},company);
      const [loading, setLoading] = React.useState(true);
      const [isAuthenticated, setIsAuthenticated] = React.useState(false);

      const host = window.location.host;
      const companyId = company_id?.slice();
      const domain = copyComp && copyComp.domain ? copyComp.domain : '';
      const urlName = copyComp && copyComp.urlName ? copyComp.urlName : '';
  
      useEffect(() => {
        const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
          if (user) {
                user.getIdTokenResult(true)
                .then(async idTokenResult=> {
                    // Optionally, you can check custom claims or other conditions here
                    const tokenValid = idTokenResult.token && idTokenResult.authTime && new Date(idTokenResult.expirationTime).getTime() > Date.now();
                    if (!tokenValid) {
                        setIsAuthenticated(false);
                        setLoading(false);
                        firebase.auth().signOut();
                        props.logout_user();
                    } else {
                        setIsAuthenticated(true);
                        setLoading(false);
                    }
                })
                .catch(e=> {
                    setIsAuthenticated(false);
                    setLoading(false);
                    console.log('Error validating token:', e);
                    firebase.auth().signOut();
                    props.logout_user();
                })
          }
          else {
            setIsAuthenticated(false);
            setLoading(false);
            firebase.auth().signOut();
            props.logout_user();
          }
        });
      
        return () => unsubscribe();
      }, []);

      if (loading) {
        return (
          <Backdrop
            style={{
              zIndex: 111125,
              color: '#fff',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            open={loading}
          >
            <ColorCircularProgress />
          </Backdrop>
        );
      };

      return isAuthenticated ? <WrappedComponent {...props} /> : <Navigate to={domain === host ? '/': urlName ? `/${urlName}` : `/company/${companyId}`} />;
    };
  
    const mapDispatchToProps = (dispatch) => ({
      logout_user: () => dispatch(remove_user()),
    });

    const mapStateToProps = state => {
      return {
        user: state.user,
        company:state.company,
        company_id: state.company_id,
      }
    };
  
    return connect(mapStateToProps, mapDispatchToProps)(AuthComponent);
  };

export default withAuth;